/**
 * Use to add space between components when creating pages in amplience
 *
 * @module views/components/Price
 * @memberof -Common
 */
import React from 'react';

import PropTypes from 'prop-types';
import { Price as PalPrice } from 'web-palette/dist/components/Price/Price';

import { spreadProps } from '@ulta/core/utils/dom/dom';

/**
 * Represents a Price component
 *
 * @method
 * @param {PriceProps} props - React properties passed from composition
 * @returns Price
 */
export const Price = function( props ){
  return (
    <PalPrice
      { ...spreadProps( {
        ...props
      } ) }
    />
  );
};

/**
 * Property type definitions
 * @typedef PriceProps
 * @type {object}
 * @property {string} appDownloadLabel - Sets the app download label to display
 * @property {object} appDownloadAction - Sets the app download action
 * @property {boolean} disabled - Sets the disabled state of the price
 * @property {object} externalAppDownloadAction - Sets the app download action from web-site
 * @property {string} kitPrice - Sets the kit value to display
 * @property {string} kitPriceAccessibilityLabel - Sets the kit price accessibility label for screen readers
 * @property {string} listPrice - Sets the list price to display
 * @property {string} listPriceAccessibilityLabel - Sets the list price accessibility label for screen readers
 * @property {string} message - Sets the message to display when there is no price
 * @property {string} originalPriceLabel - Sets the original price text to display with list price
 * @property {string} priceLabel - Sets the price label to display
 * @property {string} salePrice - Sets the sale price to display
 * @property {string} salePriceAccessibilityLabel - Sets the sale price accessibility label for screen readers
 * @property {string} variant - sets the variation of price
 */
export const propTypes =  {
  appDownloadLabel: PropTypes.string,
  appDownloadAction: PropTypes.object,
  disabled: PropTypes.bool,
  externalAppDownloadAction: PropTypes.object,
  kitPrice: PropTypes.string,
  kitPriceAccessibilityLabel: PropTypes.string,
  listPrice: PropTypes.string,
  listPriceAccessibilityLabel: PropTypes.string,
  message: PropTypes.string,
  originalPriceLabel: PropTypes.string,
  priceLabel: PropTypes.string,
  salePrice: PropTypes.string,
  salePriceAccessibilityLabel: PropTypes.string,
  variant: PropTypes.oneOf( ['default', 'PDP', 'large'] )
};

Price.propTypes = propTypes;
export default Price;